const DEFAULT_POLL_INTERVAL_MS = 2000
const DEFAULT_MAX_ATTEMPTS = 15
const DEFAULT_EPSILON = 0.01

export const paymentFinalizationDefaults = {
  intervalMs: DEFAULT_POLL_INTERVAL_MS,
  maxAttempts: DEFAULT_MAX_ATTEMPTS,
  epsilon: DEFAULT_EPSILON,
}
